import React from 'react';
import styled from 'styled-components';
import { themeColor } from '../../Theming';
import { ArrowHead } from '../../Common/Svg/Icons';
import UnstyledButton from '../../Common/Buttons/UnstyledButton';

const StyledButton = styled(UnstyledButton)`
  border-top: 1px solid ${themeColor('lightestGrey')};
  color: ${themeColor('darkestGrey')};
  font-size: 1rem;
  padding: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  text-transform: uppercase;
  width: 100%;
`;

interface MenuButtonProps {
  onClick(): void;
  hideArrow?: boolean;
  arrowDirection?: 'up' | 'down' | 'right';
}

const MenuButton: React.FC<MenuButtonProps> = ({
  children,
  onClick,
  hideArrow = false,
  arrowDirection = 'right',
}) => {
  return (
    <StyledButton onClick={onClick}>
      {children}
      {!hideArrow && (
        <ArrowHead
          direction={arrowDirection}
          rotateDimensions
          width={12}
          height={6}
        />
      )}
    </StyledButton>
  );
};

export default MenuButton;
